import { render, staticRenderFns } from "./VersionView.vue?vue&type=template&id=380e3aa4&scoped=true"
import script from "./VersionView.vue?vue&type=script&lang=js"
export * from "./VersionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e3aa4",
  null
  
)

export default component.exports